import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addVendor({ commit }, item) {
    return this.$axios.$post('admin/vendors/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeVendor({ commit }, item) {
    return this.$axios.$delete(`admin/vendors/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateVendor({ commit }, item) {
    return this.$axios.$put(`admin/vendors/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchVendors({ commit }) {
    return this.$axios.$get('admin/vendors').then((response) => {
      commit('load', response.data)
    })
  },
}
